<div class="jc-v3-jps-jd-wrap">
  <div class="jc-v3-jps-jd-empty jc-v3-cps-card" *ngIf="!hasContent">
    <ng-icon name="tablerFileText"></ng-icon>
    <h4>No job description available</h4>
    <p>The recruiter hasn't published a detailed description for this role yet.</p>
  </div>
  <div class="jc-v3-jps-jd-body jc-v3-cps-card" *ngIf="hasContent" [innerHTML]="jobDescription"></div>
</div>
